<template>
  <div id="app">
    <Toaster
      :toast-options="{
        duration: 3000,
        unstyled: true,
        classes: {
          toast: 'toasty bg-white rounded-xl border border-gray-300 p-4 flex items-start gap-3',
          error: 'toasty-error text-red-400',
          success: 'toasty-success text-green-400',
          icon: 'pr-1',
          title: 'toasty-title text-sm leading-5 font-medium text-gray-900',
          description: 'toasty-description pb-6 mt-2 text-sm leading-5 text-gray-500',
          actionButton:
            'pl-8 pb-4 absolute bottom-0 left-4 text-sm leading-5 font-medium text-gray-700 hover:text-gray-500 focus:outline-none focus:underline transition ease-in-out duration-150',
        },
      }"
    />
    <TooltipProvider>
      <router-view></router-view>
      <MultiChatSheet />
      <MultiEmailSheet />
    </TooltipProvider>
  </div>
</template>

<script>
import { useCurrentUserStore } from '@/stores/currentUser.ts';
import { TooltipProvider } from './components/ui/tooltip';
import { MultiChatSheet } from './components/shared/MultiChat';
import { MultiEmailSheet } from './components/shared/MultiEmail';

export default {
  name: 'App',
  components: { TooltipProvider, MultiChatSheet, MultiEmailSheet },
  setup() {
    const currentUserStore = useCurrentUserStore();
    return { currentUserStore };
  },
  mounted() {
    const unreadMessages = this.currentUserStore.currentUserAccountDetails.unreadMessages;
    this.updateDocumentTitle(unreadMessages);

    this.$watch(
      () => this.currentUserStore.currentUserAccountDetails.unreadMessages,
      newUnreadMessages => {
        this.updateDocumentTitle(newUnreadMessages);
      }
    );
  },
  methods: {
    updateDocumentTitle(unreadMessages) {
      document.title =
        unreadMessages > 0
          ? `(${unreadMessages}) Humaniz.io - Modern agent recruiting`
          : 'Humaniz.io - Modern agent recruiting';
    },
  },
};
</script>
